import React, { useState, useRef, useEffect } from 'react';
import { DatePicker } from 'antd';
import cn from 'classnames';
import { ReactComponent as ArrowDownIcon } from '../../../../resource/arrows/arrow-down.svg';
import {
  setCalendarSheet,
  setLocalTask,
} from '../../store/actions/calendarActions';
import { useCalendarDispatch, useCalendarState } from '../../context/CalendarContext';
import Footer from './components/Footer';
import RoundedButton from '../RoundedButton/RoundedButton';
import { views } from '../../constants/views';
import { period } from '../../constants/choosePeriodTexts';
import { containerIds } from '../../constants/containerIds';
import styles from './ChoosePeriod.module.scss';

const { MonthPicker, WeekPicker } = DatePicker;

const ChoosePeriod = ({ rootClassName, buttonBlock = true }) => {
  const [calendarOpen, setCalendarOpen] = useState(false);

  const dispatch = useCalendarDispatch();

  const containerRef = useRef();

  const { view, calendarSheet, localTask } = useCalendarState();

  const handlePickerChange = (date) => {
    dispatch(setCalendarSheet(date));
    setCalendarOpen(false);
  };

  const handleButtonClick = () => {
    setCalendarOpen((prev) => !prev);

    if (localTask) {
      dispatch(setLocalTask(null));
    }
  };

  const handleCalendarOutsideClick = (e) => {
    const current = containerRef?.current;

    if (current && !current.contains(e.target)) {
      setCalendarOpen(false);
    }
  };

  const handleEscapeDown = (e) => {
    if (e.key === 'Escape') {
      setCalendarOpen(false);
    }
  };

  // close calendar if click outside
  useEffect(() => {
    document.addEventListener('click', handleCalendarOutsideClick);

    return () =>
      document.removeEventListener('click', handleCalendarOutsideClick);
  }, []);

  // close calendar if escape down
  useEffect(() => {
    if (calendarOpen) {
      document.addEventListener('keydown', handleEscapeDown);
    } else {
      document.removeEventListener('keydown', handleEscapeDown);
    }
  }, [calendarOpen]);

  const pickerProps = {
    getCalendarContainer: () =>
      document.getElementById(containerIds.choosePeriod),
    open: calendarOpen,
    className: styles.picker,
    dropdownClassName: styles.dropdown,
    onChange: handlePickerChange,
    value: calendarSheet,
    renderExtraFooter: () => (
      <Footer onFastPeriodBtnClick={handlePickerChange} />
    ),
  };

  return (
    <div
      ref={containerRef}
      id={containerIds.choosePeriod}
      className={cn(styles.root, rootClassName)}
    >
      <RoundedButton
        block={buttonBlock}
        className={styles.button}
        onClick={handleButtonClick}
      >
        Выбрать {period[view]} <ArrowDownIcon />
      </RoundedButton>
      {view === views.month && <MonthPicker {...pickerProps} />}
      {view === views.week && <WeekPicker {...pickerProps} />}
      {view === views.day && <DatePicker {...pickerProps} showToday={false} />}
    </div>
  );
};

export default ChoosePeriod;
